export class EcaApiGateway {
  static lookup(environment: any, serviceName: string, options: any = {}) {
    const client: string = options.client || 'all';
    const apiversion: string = options.version || 'v0';
    let deployment: string = environment['deployment'];
    let apiGatewayUrl: string = environment['apiGatewayUrl'];

    const protocol: string = deployment === 'local' ? 'http' : 'https';

    if (environment['deploymentExceptions'] != null
      && environment['deploymentExceptions'][serviceName]) {
      deployment = environment['deploymentExceptions'][serviceName];
    }

    if (environment['apiGatewayExceptions'] != null
      && environment['apiGatewayExceptions'][serviceName]) {
      apiGatewayUrl = environment['apiGatewayExceptions'][serviceName];
    }

    const tag = `${client}-${deployment}-v0`;

    if (apiGatewayUrl != null) {
      return `${protocol}://${apiGatewayUrl}/${serviceName}/${tag}/${apiversion}`;
    } else {
      throw new Error(`
        Cannot construct URL for ${serviceName}, configuration provided is incomplete.
        client: ${client}
        deployment: ${deployment}
        apiversion: ${apiversion}
        apiGatewayUrl: ${apiGatewayUrl}
      `);
    }
  }
}
